/*
 * @Author: your name
 * @Date: 2019-07-08 18:01:09
 * @LastEditTime: 2020-06-18 15:51:13
 * @LastEditors: zhangkai
 * @Description: In User Settings Edit
 * @FilePath: \AIZHI_APP\src\common\js\rem.js
 */
// (function(d, w) {
//     const doc = d.documentElement;
//     function rem() {
//       const width = Math.min(doc.getBoundingClientRect().width, 768);
//       doc.style.fontSize = width / 7.5 + 'px';
//     }
//     rem();
//     w.addEventListener('resize', rem);
//   })(document, window);
  
/**
 * YDUI 可伸缩布局方案
 * rem计算方式：设计图尺寸px / 100 = 实际rem  【例: 100px = 1rem，32px = .32rem】
 */

!function (window) {

  /* 设计图文档宽度 */
  var docWidth = 750;

  var doc = window.document,
      docEl = doc.documentElement,
      resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';

  var recalc = (function refreshRem () {
      var clientWidth = docEl.getBoundingClientRect().width;
      var userAgent = window.navigator.userAgent;
    //   if (userAgent.indexOf('OPPO A73')>0){
    //       /* 8.55：小于320px不再缩小，11.2：大于420px不再放大 */
    //       docEl.style.fontSize = Math.max(Math.min(20 * (clientWidth / docWidth), 11.2), 8.55) * 4.4 + 'px';
    //   }else {
          /* 8.55：小于320px不再缩小，11.2：大于420px不再放大 */
          docEl.style.fontSize = Math.max(Math.min(20 * (clientWidth / docWidth), 11.2), 8.55) * 5 + 'px';
    //   }
      return refreshRem;
  })();

  /* 添加倍屏标识，安卓为1 */
  docEl.setAttribute('data-dpr', Boolean(window.navigator.appVersion.match(/iphone/gi)) ? window.devicePixelRatio : 1);

  if (/iP(hone|od|ad)/.test(window.navigator.userAgent)) {
      /* 添加IOS标识 */
      doc.documentElement.classList.add('ios');
      /* IOS8以上给html添加hairline样式，以便特殊处理 */
      if (window.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/) !== null && parseInt(window.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/)[1], 10) >= 8)
          doc.documentElement.classList.add('hairline');
  }

  if (!doc.addEventListener) return;
  window.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);

}(window);

